import { type InitResult } from '@airwallex/components-sdk'
import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'

import { makeSelectEnv } from '@webapp/core/stores/global'
import { initializeAirwallexSdkUseCase } from '@webapp/platform/banking/business-logic/use-cases/InitializeAirwallexSdk'
import { airwallexQueryConfig } from '@webapp/platform/banking/query-configs/airwallex'

export const useQueryAirwallexSdkInitialization = ({
  authData,
  onInitialized,
}: {
  authData: { authCode: string | undefined; codeVerifier: string | undefined }
  onInitialized?: (initResult: InitResult) => Promise<void>
}) => {
  const env = useSelector(makeSelectEnv())
  const isProd = env === 'production'

  const { data: initResult, isLoading: isInitializing } = useQuery({
    queryKey: airwallexQueryConfig.init().queryKey,
    queryFn: async () =>
      initializeAirwallexSdkUseCase({ authData, isProd, onInitialized }),
    enabled: !!authData.authCode,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: Infinity, // Don't refetch once initialized
  })

  return {
    initResult,
    isInitializing,
  }
}
